var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5265 41.7338L14.1474 44.1393L0 7.41016H9.8804L16.9889 26.138L20.3631 35.1387L22.0503 39.639L22.5265 41.7338Z",
    fill: "url(#paint0_linear_267_10436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 13.9328V21.8922H11.3697V13.8198C11.0953 13.8198 10.8208 13.8683 10.5625 13.9328Z",
    fill: "url(#paint1_linear_267_10436)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35059 16.8387V21.9081H10.5624V13.9326C9.28698 14.2878 8.35059 15.4502 8.35059 16.8387Z",
    fill: "url(#paint2_linear_267_10436)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8404 11.3496C14.566 11.3496 14.2915 11.398 14.0332 11.4626V21.9082H14.8404V11.3496Z",
    fill: "url(#paint3_linear_267_10436)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8213 14.3684V21.908H14.0331V11.4624C12.7577 11.8176 11.8213 12.98 11.8213 14.3684Z",
    fill: "url(#paint4_linear_267_10436)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4893 8.24973V21.9081H18.2965V8.13672C18.0059 8.13672 17.7476 8.18515 17.4893 8.24973Z",
    fill: "url(#paint5_linear_267_10436)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2773 11.1555V21.9079H17.4892V8.24951C16.2137 8.60469 15.2773 9.76711 15.2773 11.1555Z",
    fill: "url(#paint6_linear_267_10436)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5564 20.9235C36.5242 19.2444 36.2013 17.5815 35.7815 15.9348C35.5555 15.0791 35.281 14.2234 35.0066 13.3032C34.829 14.6109 34.7644 15.8702 34.4899 17.0649C34.4899 17.0972 34.4738 17.1295 34.4738 17.1618C33.6827 20.5844 31.5677 23.1999 29.0169 25.4763C26.7889 27.4621 24.448 29.351 22.2361 31.3368C19.54 33.7585 17.3604 36.5515 16.1496 40.0226C16.1335 40.0872 16.0527 40.1356 15.9397 40.2486C16.0366 38.7795 16.3918 37.4556 16.9568 36.1963C18.1354 33.5809 19.992 31.4659 21.9617 29.4317C23.8345 27.4943 25.7718 25.6054 27.58 23.6035C28.5003 22.5864 29.3075 21.4401 30.034 20.2615C32.0682 16.9519 32.2781 13.4485 30.9381 9.83209C30.147 7.68486 29.0169 5.7475 27.7092 3.95544C26.6921 2.58314 25.5781 1.27543 24.448 0C24.9646 2.38941 25.5781 4.79496 25.9978 7.2328C27.015 13.3032 25.4489 18.6309 21.2352 23.1676C19.9759 24.5237 18.765 25.9122 17.5219 27.2845C13.4534 31.7888 12.3395 37.0681 13.5019 42.8963C13.9539 45.1889 14.2768 47.2877 15.1971 49.7094C15.2132 49.7578 15.2455 49.8224 15.3101 50C15.7298 48.9667 16.1819 47.659 16.6339 46.5773C16.6985 46.432 16.747 46.3029 16.8115 46.1576C18.7327 41.8631 21.7679 38.4566 25.4651 35.6151C27.467 34.0814 29.5174 32.5961 31.5032 31.03C33.9572 29.0765 35.8461 26.7033 36.3789 23.5066C36.5403 22.6348 36.5887 21.7791 36.5564 20.9235Z",
    fill: "url(#paint7_linear_267_10436)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0202 28.8828C32.9879 27.6719 32.7296 26.4772 32.3744 25.2986C32.1807 24.6851 31.9546 24.0716 31.7448 23.4097C31.5994 24.3623 31.5349 25.2502 31.3088 26.122C31.3088 26.1382 31.2927 26.1705 31.2927 26.1866C30.6308 28.6567 28.8871 30.5295 26.7561 32.1763C24.8994 33.6131 22.9782 34.9531 21.1216 36.4062C18.8936 38.1498 17.0693 40.1517 16.0683 42.6541C16.0521 42.7026 15.9876 42.7349 15.9068 42.8156C15.9876 41.75 16.2782 40.8137 16.7464 39.9096C17.715 38.0206 19.2649 36.503 20.8955 35.0339C22.4454 33.6293 24.0599 32.2731 25.5613 30.8363C26.3363 30.1097 26.9982 29.2702 27.5956 28.4307C29.2746 26.0574 29.4522 23.5227 28.3544 20.9234C27.6924 19.3736 26.7561 17.9851 25.6744 16.6935C24.8348 15.6926 23.9146 14.7562 22.9621 13.8359C23.398 15.5634 23.8984 17.2909 24.2375 19.0345C25.077 23.4097 23.7854 27.2521 20.282 30.5134C19.2326 31.482 18.2317 32.483 17.1984 33.484C13.808 36.7291 12.8878 40.523 13.8565 44.7207C14.2439 46.3674 14.5023 47.885 15.2772 49.6286C15.2933 49.6609 15.3095 49.7094 15.3741 49.8385C15.7131 49.0959 16.1006 48.1595 16.4719 47.3845C16.5203 47.2877 16.5688 47.1746 16.6172 47.0778C18.2155 43.978 20.7341 41.5402 23.8016 39.4898C25.4645 38.3758 27.1758 37.3103 28.8064 36.1801C30.8406 34.7756 32.4067 33.0642 32.8587 30.7555C33.004 30.1097 33.0363 29.4963 33.0202 28.8828Z",
    fill: "url(#paint8_linear_267_10436)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10448 24.2007C2.68472 24.5074 2.36183 24.9595 2.10352 25.5084C6.33341 25.8959 8.36764 28.6889 9.77223 32.1761C10.2081 33.2417 10.531 34.3718 10.9669 35.6634C11.0799 34.9369 11.2575 34.2265 11.4513 33.5646C11.1284 32.5798 10.8539 31.6918 10.5149 30.8361C9.15873 27.4296 7.17294 24.685 3.10448 24.2007Z",
    fill: "url(#paint9_linear_267_10436)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3455 22.4087C15.0843 22.4087 11.8392 22.4248 8.57799 22.4087C7.94835 22.4087 7.46401 22.5701 7.06039 23.0868C6.91509 23.2644 6.57605 23.3128 6.31774 23.3612C5.5105 23.5227 4.68713 23.5711 3.91218 23.8133C3.62158 23.9101 3.36326 24.0393 3.12109 24.2169C7.18955 24.6851 9.15919 27.4458 10.5315 30.8523C10.8705 31.708 11.145 32.596 11.4679 33.5808C11.9199 32.1278 12.5496 30.7878 13.3084 29.5446C14.6484 26.8969 16.5857 24.6528 18.6523 22.441C18.5392 22.4087 18.4424 22.4087 18.3455 22.4087Z",
    fill: "url(#paint10_linear_267_10436)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9845 34.921C29.9522 34.0491 29.7424 33.1935 29.4518 32.3378C29.2903 31.8858 29.1127 31.4499 28.919 30.9817C28.806 31.6597 28.7414 32.3055 28.5638 32.9352C28.5638 32.9513 28.5477 32.9675 28.5477 32.9836C27.9987 34.7595 26.5457 36.1157 24.7859 37.2942C23.2522 38.3275 21.6377 39.2962 20.104 40.3294C18.2474 41.5887 16.7459 43.0256 15.9064 44.8338C15.8902 44.8661 15.8418 44.8822 15.7611 44.9629C15.8257 44.2041 16.0678 43.5261 16.4553 42.8641C17.2625 41.508 18.538 40.4101 19.8941 39.3607C21.1857 38.3598 22.5096 37.3749 23.7688 36.3417C24.4146 35.8089 24.9635 35.2116 25.464 34.6142C26.8686 32.9029 27.0139 31.0785 26.0937 29.2057C25.5447 28.0918 24.7698 27.0908 23.8657 26.1544C23.1715 25.4279 22.3965 24.7498 21.6216 24.0879C21.9768 25.331 22.3965 26.5742 22.6871 27.8335C23.3814 30.9817 22.3158 33.7424 19.4098 36.0995C18.538 36.7937 17.7146 37.5202 16.8589 38.2306C14.0498 40.5554 13.291 43.3 14.0982 46.3191C14.4211 47.5138 14.631 48.5955 15.2767 49.8548C15.2929 49.887 15.309 49.9193 15.3575 50.0001C15.6481 49.4673 15.9548 48.7892 16.2616 48.2242C16.31 48.1434 16.3423 48.0788 16.3907 48.0143C17.7146 45.7863 19.8134 44.0265 22.3481 42.5574C23.7365 41.7663 25.1411 40.9913 26.4973 40.1841C28.1925 39.167 29.484 37.94 29.8554 36.2771C29.9684 35.8089 30.0007 35.373 29.9845 34.921Z",
    fill: "url(#paint11_linear_267_10436)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4664 39.1509C27.4503 38.5213 27.2565 37.9078 27.0144 37.2943C26.8852 36.9714 26.7238 36.6485 26.5785 36.3095C26.4816 36.7938 26.4332 37.262 26.2878 37.7141C26.2878 37.7302 26.2717 37.7302 26.2717 37.7463C25.8197 39.0218 24.6088 40.0066 23.1558 40.8461C21.8804 41.5888 20.5404 42.283 19.2811 43.0418C17.7473 43.9459 16.488 44.9791 15.7938 46.2869C15.7777 46.303 15.7454 46.3192 15.6808 46.3676C15.7292 45.8187 15.9391 45.3343 16.262 44.85C16.9401 43.8652 17.9895 43.0902 19.1196 42.3314C20.1852 41.6049 21.2991 40.9107 22.3324 40.1519C22.8652 39.7806 23.3172 39.3447 23.737 38.9088C24.8994 37.6818 25.0124 36.374 24.2536 35.0179C23.8016 34.2107 23.1558 33.5003 22.4131 32.8222C21.8319 32.3056 21.2023 31.8213 20.5403 31.3369C20.831 32.2249 21.1861 33.129 21.4283 34.0331C22.0095 36.2933 21.1216 38.2953 18.716 39.9743C17.9895 40.4748 17.2953 40.9914 16.6011 41.508C14.2762 43.1871 13.6304 45.1567 14.3085 47.3363C14.5668 48.1919 14.7444 48.983 15.2772 49.8871C15.2933 49.9033 15.3095 49.9356 15.3418 50.0001C15.5839 49.6127 15.8423 49.1283 16.1006 48.7247C16.1329 48.6763 16.1651 48.6117 16.1974 48.5633C17.2953 46.9649 19.0389 45.6895 21.1538 44.624C22.3001 44.0428 23.4787 43.4938 24.6088 42.9126C26.0134 42.1861 27.0951 41.2982 27.4018 40.1035C27.4503 39.7806 27.4826 39.4577 27.4664 39.1509Z",
    fill: "url(#paint12_linear_267_10436)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_267_10436",
    x1: 11.588,
    y1: 8.13677,
    x2: 11.588,
    y2: 44.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DEF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_267_10436",
    x1: 10.9661,
    y1: 13.8198,
    x2: 10.9661,
    y2: 21.8922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_267_10436",
    x1: 9.45649,
    y1: 13.9326,
    x2: 9.45649,
    y2: 21.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_267_10436",
    x1: 14.4368,
    y1: 11.3496,
    x2: 14.4368,
    y2: 21.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_267_10436",
    x1: 12.9272,
    y1: 11.4624,
    x2: 12.9272,
    y2: 21.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_267_10436",
    x1: 17.8929,
    y1: 8.13672,
    x2: 17.8929,
    y2: 21.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_267_10436",
    x1: 16.3833,
    y1: 8.24951,
    x2: 16.3833,
    y2: 21.9079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_267_10436",
    x1: 27.6918,
    y1: -4.16373e-7,
    x2: 14.4313,
    y2: 49.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3174E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193E65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_267_10436",
    x1: 23.2586,
    y1: 13.8359,
    x2: 23.2586,
    y2: 49.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_267_10436",
    x1: 2.21029,
    y1: 23.5308,
    x2: 11.5707,
    y2: 36.6613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_267_10436",
    x1: 10.8867,
    y1: 22.4087,
    x2: 10.8867,
    y2: 33.5808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_267_10436",
    x1: 21.8912,
    y1: 24.0879,
    x2: 21.8912,
    y2: 50.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF7900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_267_10436",
    x1: 20.7622,
    y1: 31.3369,
    x2: 20.7622,
    y2: 50.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo_only.a57411cffe747474190cf0f5c6c9c76b.svg";
export { ForwardRef as ReactComponent };